import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PriceModel } from './Price.model';
import { ApiAddressModel } from './ApiAddress.model';
export class ShippingOptionModel {
  constructor(shippingOptionModel) {
    _defineProperty(this, "logistics", void 0);
    _defineProperty(this, "title", void 0);
    _defineProperty(this, "cost", void 0);
    _defineProperty(this, "code", void 0);
    this.logistics = shippingOptionModel.logistics;
    this.title = shippingOptionModel.title;
    this.cost = shippingOptionModel.cost;
    this.code = shippingOptionModel.code;
  }
  static fromV1(shippingOption, modelContext) {
    var _shippingOption$logis, _shippingOption$logis2, _shippingOption$cost;
    return new ShippingOptionModel({
      logistics: shippingOption.logistics ? {
        deliveryTimeSlot: (_shippingOption$logis = shippingOption.logistics) == null ? void 0 : _shippingOption$logis.deliveryTimeSlot,
        pickupDetails: shippingOption.logistics.pickupDetails ? {
          address: shippingOption.logistics.pickupDetails.address ? ApiAddressModel.fromV1(shippingOption.logistics.pickupDetails.address) : undefined
        } : undefined,
        deliveryTime: (_shippingOption$logis2 = shippingOption.logistics) == null ? void 0 : _shippingOption$logis2.deliveryTime
      } : undefined,
      title: shippingOption.title,
      code: shippingOption.code,
      cost: {
        price: PriceModel.fromV1((_shippingOption$cost = shippingOption.cost) == null ? void 0 : _shippingOption$cost.price, modelContext)
      }
    });
  }
}
//# sourceMappingURL=ShippingOption.model.js.map